/**
 *
 * GenericNotFound
 *
 */

import React, { Component } from "react"
import { Helmet } from "react-helmet"
import Layout from "../Layout"
import nubeErrorIcon from "../../images/nube-error.svg"
import nubeStarsIcon from "../../images/nube-stars.svg"
import "./index.less"

class GenericNotFound extends Component {
  render() {
    return (
      <Layout backgroundLayout="#FFFFF">
        <Helmet>
          <title>ManduHr</title>
          <meta name="description" content="Description of AvailableSurveys" />
        </Helmet>
        <div className="container-error">
          <img src={nubeStarsIcon} className="container-error-stars" />
          <img src={nubeErrorIcon} />
          <h1>¡Ooops!</h1>
          <p className="container-error-description">
            Ha habido un error. Comprueba tu conexión a internet e inténtalo
            nuevamente.
          </p>
        </div>
      </Layout>
    )
  }
}

GenericNotFound.propTypes = {}

export default GenericNotFound
